/* eslint-disable camelcase */
export default {
  title: 'Форма обратной связи',
  subject: 'Тема вашего сообщения',
  body: 'Текст вашего сообщения',
  sent_success: 'Ваш отзыв успешно отправлен',
  send_another: 'Отправить еще один',
  unknown_error: 'Неизвестная ошибка при отправке вашего отзыва',
};
